export enum RelatedDocumentsViewType {
	Card = 'card',
	List = 'list',
	Compact = 'compact',
	Button = 'button'
}
